<template>
    <div v-if="!!locations.length" class="availability-locations">
        <button
            v-if="locations.length > maxNumberOfItems"
            class="availability-locations__arrows"
            type="button"
            :class="isPreviousDisabled ? 'availability-locations__arrows--disabled' : ''"
            :disabled="isPreviousDisabled"
            @click="previous"
        >
            <common-icon class="availability-locations__icon-left" name="arrow-left" size="small"></common-icon>
        </button>
        <div
            v-for="n in lastLocationIndex - firstLocationIndex + 1"
            :key="n"
            class="availability-locations__slots"
            @mouseover="onMouseOver(n + firstLocationIndex)"
            @mouseleave="onMouseLeave()"
            @click="
                goToLocation(locations[n + firstLocationIndex - 1].id, locations[n + firstLocationIndex - 1].distanceToPatient)
            "
        >
            <div :class="slotClass(n + firstLocationIndex)">
                <div v-if="$auth.getUser().canModifyPracticeMemberAvailability" class="availability-locations__slot-header">
                    <common-icon class="warning-icon" name="clock-white" size="large"></common-icon>
                    {{ getHoverTitle(locations[n + firstLocationIndex - 1].isAvailabilitySet) }}
                </div>
                <div :class="slotDataClass(n + firstLocationIndex)">
                    <p class="availability-locations__slots--practice-name">
                        <b>{{ locations[n + firstLocationIndex - 1].practiceName }}</b>
                        | {{ locations[n + firstLocationIndex - 1].name }}
                    </p>
                    <p>{{ locations[n + firstLocationIndex - 1].address }}</p>
                    <p>
                        {{ locations[n + firstLocationIndex - 1].city }}, {{ locations[n + firstLocationIndex - 1].state }}
                        {{ locations[n + firstLocationIndex - 1].zip }}
                    </p>
                    <div v-if="locations[n + firstLocationIndex - 1].distanceToPatient">
                        <hr />
                        <p>
                            <b>{{ locations[n + firstLocationIndex - 1].distanceToPatient }}</b>
                            miles away from patient
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <button
            v-if="locations.length > maxNumberOfItems"
            class="availability-locations__arrows"
            type="button"
            :class="isNextDisabled ? 'availability-locations__arrows--disabled' : ''"
            :disabled="isNextDisabled"
            @click="next"
        >
            <common-icon class="availability-locations__icon-right" name="arrow-right" size="small"></common-icon>
        </button>
    </div>
</template>

<script>
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],
        props: {
            maxNumberOfItems: { type: Number, required: true },
            hoverTitle: { type: String, required: true },
            locations: { type: Array, required: true },
        },

        inject: {
            isReferralPool: {
                default: false,
            },
        },

        data() {
            return {
                firstLocationIndex: 0,
                lastLocationIndex: 0,
                hoveredIndex: null,
            }
        },

        computed: {
            isPreviousDisabled() {
                return this.firstLocationIndex === 0
            },

            isNextDisabled() {
                return this.lastLocationIndex === this.locations.length - 1
            },
        },
        methods: {
            onMouseOver(index) {
                this.hoveredIndex = index
            },

            onMouseLeave() {
                this.hoveredIndex = null
            },

            getHoverTitle(isAvailabilitySet) {
                return isAvailabilitySet ? this.hoverTitle : this.$t('pages.profile.professional.availability.not_set')
            },

            slotClass(index) {
                return {
                    'availability-locations__slot': true,
                    'availability-locations__slot--schedule-set':
                        this.$auth.getUser().canModifyPracticeMemberAvailability &&
                        (index === this.hoveredIndex ||
                            (index === this.hoveredIndex && this.locations[index - 1]?.isAvailabilitySet)),
                    'availability-locations__slot--schedule-not-set':
                        this.$auth.getUser().canModifyPracticeMemberAvailability &&
                        index === this.hoveredIndex &&
                        !this.locations[index - 1]?.isAvailabilitySet,
                }
            },

            slotDataClass(index) {
                return {
                    'availability-locations__slot-data': true,
                    'availability-locations__slot-data__last': index - 1 === this.lastLocationIndex,
                    'availability-locations__slot-data__schedule-set':
                        index === this.hoveredIndex ||
                        (index === this.hoveredIndex && this.locations[index - 1]?.isAvailabilitySet),
                    'availability-locations__slot-data__schedule-not-set':
                        index === this.hoveredIndex && !this.locations[index - 1]?.isAvailabilitySet,
                    'availability-locations__slot-data__transparent--first':
                        index - 1 > 0 && index - 1 === this.firstLocationIndex && this.hoveredIndex !== index,
                    'availability-locations__slot-data__transparent--last':
                        index !== this.locations.length && index - 1 === this.lastLocationIndex && this.hoveredIndex !== index,
                }
            },

            previous() {
                this.firstLocationIndex = this.firstLocationIndex - 1
                this.lastLocationIndex = this.lastLocationIndex - 1
            },

            next() {
                this.firstLocationIndex = this.firstLocationIndex + 1
                this.lastLocationIndex = this.lastLocationIndex + 1
            },

            goToLocation(practiceLocationId, distance) {
                this.emitEvent({ name: 'go-to-location', payload: { practiceLocationId, distance } })
            },

            setLastLocationIndex() {
                this.lastLocationIndex =
                    this.locations.length - 1 > this.maxNumberOfItems - 1 ? this.maxNumberOfItems - 1 : this.locations.length - 1
            },
        },

        mounted() {
            this.setLastLocationIndex()
        },
    }
</script>
